import {Button, ButtonProps, Spinner} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import {useEffect, useRef} from 'react'
import CheckSVG from '@local/assets/svgs/check.svg'

export interface ButtonSpinnerProps extends ButtonProps {
	loading?: boolean,
	loaded?: boolean,
}

export const ButtonSpinner = ({children, className, loading, loaded, ...rest}: ButtonSpinnerProps) => {
	const spinnerRef = useRef<HTMLSpanElement>(null)

	useEffect(() => {
		if (!loaded && spinnerRef.current) {
			spinnerRef.current.style.transitionDuration = '0s'
			requestAnimationFrame(() => {
				if (spinnerRef.current) {
					spinnerRef.current.style.transitionDuration = ''
				}
			})
		}
	}, [loaded])

	return (
		<Button className={cx(loading && 'cursor-wait', className)} disabled={loading || loaded} {...rest}>
			<span className={cx(
				'grid place-items-center',
				'transition-[transform,opacity] duration-500 ease-quart-out',
				(loading || loaded) && '-translate-y-full opacity-0',
			)}>
				{children}
			</span>
			<span
				ref={spinnerRef}
				className={cx(
					'absolute inset-0 top-full h-full grid place-items-center',
					'transition-transform duration-500 ease-quart-out',
					loading && '-translate-y-full',
					loaded && '-translate-y-[200%]',
				)}>
				<Spinner className='w-16 h-16' svgClass='fill-current' />
			</span>
			<span className={cx(
				'absolute inset-0 top-full h-full grid place-items-center',
				'transition-transform duration-500 ease-quart-out',
				loaded && '-translate-y-full',
			)}>
				<CheckSVG className='w-14' />
			</span>
		</Button>
	)
}
